import Locale from 'rmc-calendar/lib/locale/en_US';
export default Locale;
